import React from "react";

const Img = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        d="M3.99805 3.9453C3.99805 2.84976 4.89286 1.9217 6.02808 1.99168C10.4743 2.26577 14.3728 3.76376 17.4274 6.68261C18.2936 7.51037 18.1233 8.86194 17.2246 9.55321C15.9823 10.5087 14.102 11.948 13 12.7582V14.5C13 15.2177 12.445 16 11.5003 16C11.3195 16 11.153 15.9714 11.0021 15.92V16.0039C11.0021 16.7174 10.4462 17.4962 9.5 17.4962C8.74619 17.4962 8.24872 16.9993 8.07392 16.4456C7.52609 16.8553 6.92715 17.3022 6.39301 17.7004C5.40358 18.438 3.99805 17.7311 3.99805 16.498V3.9453ZM11.0021 14.5C11.0021 14.7585 11.1965 15 11.5003 15C11.805 15 12 14.7574 12 14.5V12.5045C12 12.3446 12.0765 12.1943 12.2059 12.1002C12.9853 11.5332 14.3144 10.5236 15.4901 9.62364C12.7975 7.05908 9.02283 5.53628 4.99805 5.50442V16.498C4.99805 16.9094 5.46631 17.1439 5.79534 16.8987C6.58181 16.3124 7.50791 15.6211 8.20411 15.0988C8.35562 14.9852 8.55833 14.9669 8.72774 15.0516C8.89715 15.1363 9.00416 15.3094 9.00416 15.4988V16.0039C9.00416 16.2505 9.1948 16.4962 9.5 16.4962C9.81158 16.4962 10.0021 16.2513 10.0021 16.0039V14.5C10.0021 14.2239 10.2259 14 10.5021 14C10.7782 14 11.0021 14.2239 11.0021 14.5ZM16.6149 8.76055C17.0796 8.40316 17.1139 7.76616 16.7365 7.4056C13.88 4.67598 10.2177 3.25185 5.96655 2.98978C5.44805 2.95782 4.99805 3.38399 4.99805 3.9453V4.50439C9.32369 4.53667 13.3986 6.19256 16.2927 9.00819L16.6149 8.76055Z"
        fill="#fff"
      />
    </svg>
  );
};

export default Img;
